var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopeeReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".white{fill:#fff;}.shopee{fill:url(#shopee-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shopee-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3128,
    stopColor: "#fb7f31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48367,
    stopColor: "#fa5230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6272d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "shopee",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "white",
    d: "M67.49927,38.08136h-7.46497c-.80756-6.08173-4.99847-10.73138-10.0343-10.73138s-9.22675,4.64966-10.0343,10.73138h-7.46497c-1.3714,0-2.46552,1.14441-2.40399,2.5144l1.33618,29.75574c.05774,1.28577,1.11694,2.29846,2.40399,2.29846h32.32617c1.28705,0,2.34625-1.0127,2.40399-2.29846l1.33618-29.75574c.06152-1.37-1.03259-2.5144-2.40399-2.5144ZM50,29.97015c3.62665,0,6.66376,3.48291,7.39069,8.11121h-14.78137c.72693-4.6283,3.76404-8.11121,7.39069-8.11121ZM58.41687,54.30328l-3.06073,3.31696.52643,4.48242c.11505.97937-.88629,1.70697-1.78217,1.29486l-4.10046-1.88586-4.10034,1.88586c-.89587.41211-1.89734-.31549-1.78229-1.29486l.52655-4.48242-3.06073-3.31696c-.6687-.72467-.28613-1.90186.68085-2.09509l4.42572-.88446,2.2088-3.93591c.48254-.85992,1.72034-.85992,2.203,0l2.2088,3.93591,4.42572.88446c.96698.19324,1.34955,1.37042.68085,2.09509Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopeeReviewsScraper);
export default __webpack_public_path__ + "static/media/shopee-reviews-scraper.f63c2d52fcd8e5f911f415f6a51a6b40.svg";
export { ForwardRef as ReactComponent };